<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentProject /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentProject from '@/components/worker/dashboard/modules/project/ContentProject.vue'

export default 
{
  name: 'Project',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentProject
  }
}
</script>
<style>

</style>